export function getCardFrameSourceIndices(credits = []) {
  return credits.reduce((indices, credit, index) => {
    const isSideBySide = credit?.options?.block_inset === "sidebyside";
    const followsSideBySide =
      index > 0 && credits[index - 1]?.options?.block_inset === "sidebyside";

    if (isSideBySide || !followsSideBySide) indices.push(index);
    return indices;
  }, []);
}

export function buildCardScreenOptions(credits = [], fps = 0) {
  return getCardFrameSourceIndices(credits).map((index) => {
    const {
      screen_duration,
      transition_in,
      transition_in_duration,
      transition_out,
      transition_out_duration,
      delay,
    } = credits[index]?.options || {};

    return {
      screen_duration: Math.ceil((screen_duration || 0) * fps),
      transition_in: (transition_in || "").toLowerCase(),
      transition_in_duration:
        transition_in_duration && transition_in !== ""
          ? Math.ceil(transition_in_duration * fps)
          : 0,
      transition_out: (transition_out || "").toLowerCase(),
      transition_out_duration:
        transition_out_duration && transition_out !== ""
          ? Math.ceil(transition_out_duration * fps)
          : 0,
      delay: Math.ceil((delay || 0) * fps),
    };
  });
}
